import { useAuth } from "../context/AuthContext";

export const useAuthHook = () => {
  const { user, login, logout, loading } = useAuth();

  const isAuthenticated = !!user?.token;
  const permissions = user?.permissions || [];
  const username = user?.username || "";

  const hasPermission = (field) => {
    const normalizedField = field.startsWith("/") ? field.slice(1) : field;
    return permissions.includes(normalizedField);
  };

  return {
    isAuthenticated,
    login,
    logout,
    loading,
    permissions,
    username,
    hasPermission,
  };
};